import {
  dealTypeFromJsonQuery,
  offerTypeFromJsonQuery,
  FDealType,
  FOfferType,
  type TJsonQuery,
} from 'shared/common/packages/JsonQuery';

import type { TDeviceType } from '@cian/ui-kit';

export type TUxfbPlatform = 'desktop' | 'mobweb';
export type TUxfbViewMode = 'list' | 'map';
export type TUxfbDealType = 'sale' | 'rent';
export type TUxfbOfferType = 'flat' | 'suburban' | 'commercial';
export type TUxfbIsDaily = 'yes' | 'no';
export type TUxfbPropertyType = 'new' | 'resale' | 'resale_and_new';

export const getPlatform = (deviceType: TDeviceType): TUxfbPlatform =>
  deviceType === 'desktop' ? 'desktop' : 'mobweb';

export const getDealType = (jsonQuery: TJsonQuery): TUxfbDealType =>
  dealTypeFromJsonQuery(jsonQuery) === FDealType.Sale ? 'sale' : 'rent';

export const getOfferType = (jsonQuery: TJsonQuery): TUxfbOfferType => {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  if ((offerType & (FOfferType.Commercial | FOfferType.Garage)) !== 0) {
    return 'commercial';
  }

  if ((offerType & FOfferType.Suburban) !== 0) {
    return 'suburban';
  }

  return 'flat';
};

export const getIsDaily = (jsonQuery: TJsonQuery): TUxfbIsDaily =>
  dealTypeFromJsonQuery(jsonQuery) === FDealType.RentDaily ? 'yes' : 'no';

/**
 * Тип недвижимости. На событии выдачи атрибут называется `property_type`, на событии фильтров — `listing_type`
 * (значение одинаковое, поэтому логика общая). Для не-flat отдаём `resale_and_new` — по аналогии с аппками.
 */
export const getPropertyType = (jsonQuery: TJsonQuery): TUxfbPropertyType => {
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isNew = (offerType & FOfferType.FlatNew) !== 0;
  const isOld = (offerType & FOfferType.FlatOld) !== 0;

  if (isNew && isOld) {
    return 'resale_and_new';
  }

  if (isNew) {
    return 'new';
  }

  if (isOld) {
    return 'resale';
  }

  return 'resale_and_new';
};

export interface IGetSearchListingAttributesParams {
  jsonQuery: TJsonQuery;
  deviceType: TDeviceType;
  viewMode: TUxfbViewMode;
}

/** Атрибуты события `search_listing` (заход на выдачу). */
export const getSearchListingAttributes = ({
  jsonQuery,
  deviceType,
  viewMode,
}: IGetSearchListingAttributesParams): Record<string, string> => ({
  platform: getPlatform(deviceType),
  view_mode: viewMode,
  property_type: getPropertyType(jsonQuery),
  deal_type: getDealType(jsonQuery),
  offer_type: getOfferType(jsonQuery),
  is_daily: getIsDaily(jsonQuery),
});
